import type { HeroData } from './types';

export function statsAtLevel(hero: HeroData, level: number) {
  const atLevel = Math.max(1, Math.min(hero.maxLevel, Math.floor(level)));
  const mode = hero.calculation?.mode ?? 'bonuses';
  return hero.stats.map(stat => {
    let flat = 0, percent = 0;
    for (const bonus of hero.bonuses) {
      if (mode !== 'bonuses' || bonus.level > atLevel || !bonus.keys.includes(stat.key)) continue;
      flat += bonus.flat ?? 0;
      percent += bonus.percent ?? 0;
    }
    const precision = stat.decimals !== undefined ? 10 ** stat.decimals : ['asd', 'msd', 'arg', 'cri'].includes(stat.key) ? 1000 : 100;
    const growth = stat.scaleWithLevel
      ? (hero.statGrowthRate ?? 1) ** (atLevel - 1)
      : 1;
    const raw = mode === 'table' ? hero.calculation?.levels?.[String(atLevel)]?.[stat.key] : (stat.value + flat) * (1 + percent) * growth;
    if (raw === undefined) throw new Error(`Missing level ${atLevel} / ${stat.key} for ${hero.gameId}/${hero.id}`);
    const value = Math.round(raw * precision) / precision;
    return { ...stat, display: `${value}${stat.suffix ?? ''}` };
  });
}

export function skillRankAtLevel(hero: HeroData, skillId: string, level: number) {
  const skill = hero.skills.find(item => item.id === skillId);
  return skill ? Math.min(skill.ranks.length, 1 + skill.upgradeLevels.filter(at => at <= level).length) : 1;
}
